<template>
  <div class="top-nav">

    <b-navbar v-if="true" toggleable="lg" type="light" fixed="top" class="nav-bar">
      <!-- Logo-->
      <b-navbar-brand v-bind:to="!this.$auth.isAuthenticated ?'/':$t('router.links.account')" @click="scrollToTop">
        <img src="../assets/income.svg" class="d-inline-block align-top logo" alt="Income">
      </b-navbar-brand>
      <!-- nav-collapse -->
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav v-model="showCollapse" v-click-outside="hideCollapseMenu">

        <b-navbar-nav class="ml-auto navbar-homepage center-links" v-if="!hasToken">
<!--          <b-nav-item class="contest-btn" to="/contest" @click="scrollToTop">{{ $t('navbar.contest') }}</b-nav-item>-->
          <b-nav-item :href="'/' + $t('router.wpLinks.howItWorks')">{{ $t('navbar.howItWorks') }}</b-nav-item>
          <b-nav-item :href="'/' + $t('router.wpLinks.securityFeatures')">{{ $t('navbar.securityFeatures') }}</b-nav-item>
          <b-nav-item :to="'/' + $t('router.links.statistics')"  @click="scrollToTop">{{ $t('footer.statistics') }}</b-nav-item>
          <!-- One shared English WP page serves all locales until per-locale pages
               exist (matches movedPages); the localized slugs were removed. -->
          <b-nav-item href="/loan-originators/">{{ $t('navbar.loanOriginators') }}</b-nav-item>
          <b-nav-item :href="'/' + $t('router.wpLinks.team')">{{ $t('navbar.team') }}</b-nav-item>
          <b-nav-item :href="'/' + $t('router.wpLinks.help')">{{ $t( hasToken ? 'navbar.helpAndFaq' : 'views.logout.help') }}</b-nav-item>
          <b-nav-item href="/blog/">{{ $t('navbar.blog') }}</b-nav-item>

          <b-nav-item href="/register">
            <b-button class="get-started-btn" to="/register" variant="outline-primary">{{ $t('navbar.getStarted') }}</b-button>
          </b-nav-item>

          <b-nav-item href="/login" class="text-income-blue">
            <b-button class="menu-btn login-btn" @click="login">{{ $t('navbar.logIn') }}</b-button>
          </b-nav-item>

        </b-navbar-nav>

        <b-navbar-nav class="ml-auto" v-if="hasToken">

          <b-nav-item class="menu-btn" :to="$t('router.links.account')" @click="closeMenu">{{ $t('navbar.account') }}</b-nav-item>
          <b-nav-item class="menu-btn" to="/investments" @click="closeMenu">{{ $t('navbar.myInvestments') }}</b-nav-item>
          <b-nav-item class="menu-btn" to="/invest" @click="closeMenu">{{ $t('navbar.invest1') }}</b-nav-item>
          <b-nav-item href="/loan-originators/">{{ $t('navbar.loanOriginators1') }}</b-nav-item>
          <b-nav-item class="menu-btn" :to="'/' + $t('router.links.invite')" target="_blank" @click="closeMenu">{{ $t('navbar.inviteAFriend') }}</b-nav-item>
          <b-nav-item to="/confirm-investment" class="cart" @click="closeMenu">
            <img style="top: -15px;" src="../assets/Cart Light.svg"/>
            <div v-if="investCounter>0" class="dot-red"></div>
          </b-nav-item>

          <b-nav-item-dropdown class="nav-item-wallet" no-caret right v-bind:text="$t('navbar.depositWithdraw')" v-bind:disabled="disabledWithdraw()">

            <template #button-content v-if="$store.state.investors.investor">
              <img class="wallet-img" src="../assets/elements/wallet.svg"/>
              {{ $store.state.investors.investor.investor_available_funds | moneyFormatter }}
            </template>
            <b-dropdown-item href="/deposit" @click="closeMenu">{{ $t('navbar.depositFunds') }}</b-dropdown-item>
            <b-dropdown-item href="/withdraw" @click="closeMenu">{{ $t('navbar.withdrawFunds') }}</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item class="menu-btn d-lg-none logout-btn " @click="logout(false)">{{ $t('navbar.logout') }}</b-nav-item>
<!--          <b-nav-item-dropdown :right="false" dropleft no-caret class="menu-btn" v-bind:html="'<img src='+this.cogwheel +' >'">-->
          <b-nav-item-dropdown no-caret class="nav-item-user" :text="profileName">
<!--            <b-dropdown-text class=" username" to="/" v-if="this.$store.state.investors.investor">-->
<!--              <b-avatar-->
<!--                  :src="investorPhoto"-->
<!--                  :text="investorInitials"/>-->
<!--              <div>{{ $t('navbar.id') }}<span style="cursor: pointer" @click="$router.push('/register-complete')">-->
<!--                  {{ this.$store.state.investors.investor.investor_id }}</span>-->
<!--              </div>-->
<!--            </b-dropdown-text>-->
            <b-dropdown-item class="" to="/settings?step=1" @click="closeMenu">{{ $t('navbar.personalInformation') }}</b-dropdown-item>
            <b-dropdown-item class="" to="/settings?step=4" @click="closeMenu">{{ $t('navbar.accountSettings') }}</b-dropdown-item>
            <b-dropdown-item class="" to="/settings?step=5" @click="closeMenu">{{ $t('navbar.agreements') }}</b-dropdown-item>
            <b-dropdown-item class="" to="/settings?step=7" @click="closeMenu">{{ $t('navbar.accountStatement') }}</b-dropdown-item>
            <b-dropdown-item class="" to="/settings?step=8" @click="closeMenu">{{ $t('navbar.accountAttachments') }}</b-dropdown-item>
            <b-dropdown-item  class="d-none d-lg-block logout-btn" @click="logout(false)">{{ $t('navbar.logout') }}</b-dropdown-item>
          </b-nav-item-dropdown>

        </b-navbar-nav>
      </b-collapse>

    </b-navbar>

    <div class="top-sticker" v-if="problems && $route.path !== '/login'">
      <b-alert dismissible :show="showBar[problem.problem_id]" :variant="problem.type" v-for="problem in problems" :key="problem.short" @dismissed="closeTopBar(problem)">
        {{ $t(problem.message_i18n) }}
        <b-button v-if="problem.linkURL" class="btn income-btn" @click.native="closeTopBar(problem)" :to="problem.linkURL">{{ $t(problem.linkTitle_i18n) }}</b-button>
      </b-alert>
    </div>

    <b-modal ref="prelogout" size="sm" hide-footer :title="$t('navbar.pleaseNoteThat')">
      <b-button class="mt-3 btn income-btn confirm-btn" block @click="$refs.prelogout.hide(); $router.push({ path: '/confirm-investment'})">{{ $t('navbar.cancelAndConfirmInvestments') }}</b-button>
      <b-button class="mt-2 btn force-logout" block @click="logout(true)">{{ $t('navbar.continueToLogOut') }}</b-button>
    </b-modal>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
import imageMixin from '../mixins/image'
import moneyMixin from '../mixins/money'
import languageMixin from '../mixins/language'
import localStorageHelper from '@/helpers/localStorageHelper'
import {investorStatuses} from '@/config/investorStatuses'
import investorAPI from '@/api/investor'

export default {
  name: 'Navbar',
  mixins: [imageMixin, moneyMixin, languageMixin],
  data()
  {
    return {
      showCollapse: false,
      env: process.env,
      problems: [],
      showBar: [],
      cogwheel: this.getSrc('cogwheel.svg'),
      investorPhoto: '',
      investorInitials: '',
      hasToken: localStorage.getItem('accessToken') !== null,
      profileName: localStorage.getItem('profileName') ? localStorage.getItem('profileName') : 'My account'
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  computed: {
    investCounter()
    {
      return this.$store.getters['invests/investCount']
    }
  },
  watch: {
    '$store.state.investors.investor':
        {
          handler(investor)
          {
            if (investor)
            {
              if (investor.investor_is_company && investor.investor_is_company === 1 && investor.investor_comp_name)
              {
                this.profileName = investor.investor_comp_name
              } else {
                this.profileName = investor.investor_first_name + ' ' + investor.investor_last_name
              }
              this.investorPhoto = investor.investor_photo
              this.investorInitials = investor.investor_email.substring(0, 2)
              if (!investor.investor_photo && this.$auth && this.$auth.isAuthenticated && this.$auth.user && this.$auth.user.picture)
              {
                this.investorPhoto = this.$auth.user.picture
                investorAPI.update(
                    {
                      investor_photo: this.investorPhoto
                    })
                    .then()
                    .catch((error) =>
                    {
                      console.error('Error in updating investor photo ', error)
                    })
              }

              if (investor.problems)
              {
                const problems = investor.problems
                problems.forEach((problem, i, obj) =>
                    {
                      if (problem.show_once)
                      {
                        let alreadyShowed = localStorageHelper.getJson('showed_messages')
                        alreadyShowed = alreadyShowed || []
                        if (alreadyShowed.indexOf(investor.investor_id + '_' + problem.problem_id) !== -1)
                        {
                          // console.log('catch problem and find: ' + problem.problem_id + ' in localstorage! Try to delete...')
                          obj.splice(i, 1)
                          this.$set(this.showBar, problem.problem_id, false)
                        } else {
                          this.$set(this.showBar, problem.problem_id, true)
                        }
                      }
                      if (problem.problem_id) {
                        this.$set(this.showBar, problem.problem_id, true)
                      }
                    }
                )
                if (problems.length)
                {
                  this.$root.$emit('topinfobar', true)
                }
                this.problems = problems
              }
            }
          },
          deep: true,
          immediate: true
        },
    '$store.state.investors.already_exists_message': function (alreadyExistsMessage)
    {
      if (alreadyExistsMessage)
      {
        localStorageHelper.set('loginError', alreadyExistsMessage)
        this.$auth.logout({
          returnTo: window.location.origin
        })
      }
    }
  },
  methods: {
    closeTopBar(problem)
    {
      this.$root.$emit('topinfobar', false)
      this.$set(this.showBar, problem.problem_id, false)
      if (problem.show_once === true)
      {
        const alreadyShowed = localStorageHelper.getJson('showed_messages') || []
        alreadyShowed.push(this.$store.state.investors.investor.investor_id + '_' + problem.problem_id)
        localStorageHelper.setAsJson('showed_messages', alreadyShowed)
        this.$store.state.investors.investor.problems = this.problems.filter(p => p.problem_id !== problem.problem_id)
      }
    },
    // Log the user in
    login()
    {
      this.$router.push('/login')
    },
    // Log the user out
    logout(force = false)
    {
      this.closeMenu()
      const investCount = parseInt(this.$store.getters['invests/investCount'])
      if (investCount && !force)
      {
        this.$refs.prelogout.show()
      }
      else
      {
        this.$auth.logout({
          returnTo: window.location.origin + '/logout'
        })
      }
    },
    closeMenu()
    {
      this.$root.$emit('bv::toggle::collapse', 'nav-collapse')
    },
    hideCollapseMenu(event)
    {
      if (event && event.target && event.target.className !== 'navbar-toggler-icon')
      {
        this.showCollapse = false
      }
    },
    scrollToTop()
    {
      this.closeMenu()
      window.scrollTo(0, 0)
    },
    disabledWithdraw()
    {
      if (this.$store.state.investors.investor && this.$store.state.investors.investor.investor_account_status)
      {
        const accountStatus = this.$store.state.investors.investor.investor_account_status
        return !(accountStatus === investorStatuses.APPROVED || accountStatus === investorStatuses.INVESTMENT_SUSPENDED || accountStatus === investorStatuses.SUSPENDED)
      }
      return true
    }
  }
}
</script>

<style lang="scss">
.navbar .navbar-nav .dropdown-toggle{
  z-index: 2 !important;
}
</style>
<style lang="scss" scoped>

.navbar .navbar-collapse .navbar-nav .nav-item-user::after,
.navbar .navbar-collapse .navbar-nav .dropdown-item-user::after{
  z-index: 1;
}

nav {
  padding: 0 2rem;
}

.submenu {
  position: fixed;
  right: 10px;
  top: 75px;
  z-index: 1030;
  background: #fff;
  text-align: justify;
  border: 1px solid #c3c3c3;
  border-radius: 14px;

  a {
    width: 100%;
    text-align: left;
    max-width: 200px;
  }

  a:hover, a:focus, a:visited, a:active, a:target {
    box-shadow: none !important;
  }
}

.deposit-menu {
  img {
    max-width: 22px;
  }
}

.logo {
  max-width: 400px;
  min-width: 110px;
  margin-top: 5px;
}

.menu-btn {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  text-align: left;
  color: #000000;
  mix-blend-mode: normal;
  //opacity: 0.8;
  background-color: transparent;
  border: none;
  // margin: 5px 25px;
  @media screen and (min-width: 990px) and (max-width: 1381px) {
    margin: 5px 14px;
  }
  @media screen and (min-width: 990px) and (max-width: 1120px) {
    font-size: 13px;
    margin: 5px 5px 5px;
  }
}
.navbar-mobile-item-hide{
  @media screen and (min-width: 990px) and (max-width: 1120px) {
    margin-top: 10px;
  }
}

.menu-btn.disable-hover:hover {
  color: inherit;
  background-color: inherit;
  border-color: inherit;
}

.get-started-btn {
  color: #fff !important;
  background: #30A7FE;
  box-sizing: border-box;
  border-radius: 16px;
  transition: color 0.2s ease-in-out, background-color 0.3s ease-in-out, border-color 0.3s ease-in-out, box-shadow 0.2s ease-in-out;
  &:hover{
    background: #3A4045;
    border-color: #3A4045 !important;
    color: #FFFFFF !important;
  }
  @media (max-width:978px) {
    padding-left: 0;
    padding-bottom: 3px;
  }
}

.login-btn{
  @media screen and (min-width: 990px) and (max-width: 1120px) {
    margin-top: 5px;
  }
}

.btn-secondary {
  color: #000;
  background-color: transparent;
  border-color: transparent;
}

.btn-secondary.focus, .btn-secondary:focus, .btn-secondary:hover {
  color: #000;
  background-color: transparent;
  border-color: transparent;
}

.btn-secondary.focus, .btn-secondary:focus {
  box-shadow: 0 0 0 .2rem rgba(130, 138, 145, .5)
}

.btn-secondary.disabled, .btn-secondary:disabled {
  color: #000;
  background-color: transparent;
  border-color: transparent;
}

.btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show > .btn-secondary.dropdown-toggle {
  color: #000;
  background-color: transparent;
  border-color: transparent;
}

.btn-secondary:not(:disabled):not(.disabled).active:focus, .btn-secondary:not(:disabled):not(.disabled):active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: none;
}

.nav-bar {
  height: 70px;
  background: #F5FBFF;
  box-shadow: 0px 4px 16px rgba(48, 167, 254, 0.1);
  white-space: nowrap;

  .nav-item {
    margin-right: 1.4rem;
    @media screen and (min-width: 990px) and (max-width: 1381px) {
      margin-right: 0.1rem;
    }
    @media screen and (min-width: 990px) and (max-width: 1120px) {
      margin-right: 1px;
      padding-right: 2px !important;
    }
    .login-btn{
      @media screen and (min-width: 990px) and (max-width: 1120px) {
        padding: 10px 10px 10px 10px;
      }
    }
  }

  .center-links {
    margin-right: 1.4rem;
    font-weight: bold;
    font-size: 14px;
    @media screen and (min-width: 990px) and (max-width: 1120px) {
      font-size: 13px;
      margin-right: 0.4rem;
    }
  }
}

.navbar-light .navbar-nav .nav-link,
.navbar-light .navbar-text {
  color: #000000;
}

@media only screen and (min-width: 320px) and (max-width: 990px) {
  .navbar .show {
    color: #fff;
    background-color: var(--blue-income);
    min-width: 100%;
    box-shadow: 0 1px 9px var(--blue-income);
    border: none;
    border-radius: 4px;

    .b-nav-dropdown {
      border: none;
    }
  }
}

.navbar .show {
  /*background: #fff;*/
}

.top-filters {
  display: inline-block;
  position: absolute;
  background: #FFFFFF;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin-top: 315px;
  padding: 20px;
}

.invest-counter {
  font-size: 11px;
  margin-right: 2px;
}

.invest-counter-active {
  border: 4px solid #E64B4B;
  background: #E64B4B;
  border-radius: 14px;
  text-shadow: 1px 1px 2px black;
  color: white;
  font-size: 11px;
  display: inline-block;
  text-align: center;
  min-width: 25px;
  margin-right: 1px;
}

.logout-btn {
  //text-align: left;

  img {
    width: 22px;
  }
}

.username {
  text-decoration: none;
}

.top-sticker {
  position: fixed;
  top: auto;
  z-index: 1;
  padding-right: 5%;
  width: 90%;
  max-width: 1180px;

  .btn{
    max-height: initial;
  }
}

.actual-balance {
  font-size: 14px;
}

@media only screen and (min-width: 320px) and (max-width: 990px) {
  .login-btn {
    margin: 10px 0 5px 0;
    padding-left: 5px;
  }
  .actual-balance {
    padding-left: 1.75em;
  }
}

@media only screen and (min-width: 320px) and (max-width: 480px) {
  .nav-bar {
    white-space: normal;

    .btn, .menu-btn {
      text-align: left;
      float: none;
      width: 90%;
    }
  }
  .deposit-menu {
    top: 225px;
  }
}

@media only screen and (min-width: 1054px) {
  .deposit-menu {
    right: 180px;
  }
}

@media only screen and (max-width: 320px) {
  .menu-btn {
    margin: 3px 5px !important;
  }
  .dropleft {
    max-width: 245px !important;
    white-space: normal !important;
  }
  .nav-link {
    padding: 0.25rem 1rem !important;
  }
}

.confirm-btn {
  background-color: #30a7fe !important;
  border-color: #30a7f1 !important;
}

.force-logout {
  background-color: #cdcbcb;
}

.force-logout:hover {
  background-color: #dcdbdb;
}

.navbar-mobile-item {
  margin-right: 5px;
}

.navbar-mobile-item > .actual-balance {
  padding-left: 0;
}

.confirm-investment-mobile {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px !important;
  margin-right: 5px !important;
}

.navbar-mobile-flex {
  display: flex;
  border: none;
  padding-right: 0;
  padding-left: 0;
}
.contest-btn a{
  color: #EC4C60 !important;
}
@media screen and (max-width: 395px) {
  .navbar-brand {
    margin-right: 0px;
  }
  .logo {
    width: 100px;
  }

  .navbar {
    padding: 0 .45rem;
  }
}

@media screen and (max-width: 991px) {
  .navbar-mobile-item-hide {
    display: none;
  }
}

@media screen and (min-width: 991px) {
  .navbar-mobile-flex {
    display: none !important;
  }
}
</style>
